module.exports = __webpack_public_path__ + "static/img/beta_bg_10.a48e39a1.svg";